<template>
  <div>
    <div class="row">
      <div class="col-lg-12" style="padding-top: 60px">
        <div class="row">
          <div class="col-lg">
            <card class="card-eprf">
              <div class="row">
                <div class="col-lg-3">
                  <p style="color: #5e99ff; font-size: 24px; font-weight: 300">
                    COLLECTION SCHEDULE
                  </p>
                </div>
                <div class="col-lg" style="">
                  <p
                    style="
                      width: 6px;
                      height: 70%;
                      background-color: #0baa00;
                      color: #0baa00;
                      display: inline-block;
                    "
                  >
                    |
                  </p>
                  <p
                    class=""
                    style="
                      display: inline;
                      padding-left: 8%;
                      color: #A5A5A5;
                      position: absolute;
                      top: 15%;
                    "
                  >
                    On schedule
                  </p>
                </div>
                <div class="col-lg" style="">
                  <p
                    style="
                      width: 6px;
                      height: 70%;
                      background-color: #ff9900;
                      color: #ff9900;
                      display: inline-block;
                    "
                  >
                    |
                  </p>
                  <p
                    class=""
                    style="
                      display: inline;
                      padding-left: 8%;
                      color: #A5A5A5;
                      position: absolute;
                      top: 15%;
                    "
                  >
                    Delay
                  </p>
                </div>
                <div class="col-lg-6"></div>
              </div>
              <div class="row">
                <div class="col-lg" style="width: 1200px">
                  <full-calendar
                    :events="demoEvents"
                    locale="ms-my"
                    @moreClick="moreClick"
                    @eventClick="eventClick"
                    @dayClick="dayClick"
                    @changeMonth="handleMonthChange"
                    ref="calendar"
                    style="color: #000000 !important"
                    :firstDay="1"
                  >
                  </full-calendar>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
      <modal :show.sync="modals.noti" class="modal-eprf" centered>
        <b-card
          class="card"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row">
              <div class="col-lg">
                <h4 class="mb-0">{{ tajuk }}</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    "
                    class="tim-icons icon-simple-remove"
                    @click="modals.noti = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>
          <div class="row" v-for="(item, index) in tableData" :key="index" style=" margin: 5px;">
            <div class="col-lg-3">
              <p class="cust">Job No.</p>
              <p class="custtitle">{{ item.jobno }}</p>
            </div>
            <div class="col-lg-3">
              <p class="cust">Customer</p>
              <p class="custtitle">{{ item.customer }}</p>
            </div>
            <div class="col-lg-3">
              <p class="cust">Ship</p>
              <p class="custtitle">{{ item.ship }}</p>
            </div>
            <div class="col-lg-3">
              <p class="cust">Date</p>
              <el-date-picker
                v-model="item.end"
                placeholder="Select date"
              ></el-date-picker>
            </div>
            <div class="col-lg-3">
              <p class="cust">Service Location</p>
              <el-select
                placeholder="Select"
                v-model="item.servicelocation"
                filterable
                @change="getServiceLocationCollection(item.servicelocation)"
              >
                <el-option
                  v-for="option in selects.servicelocations"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
            <div class="col-lg-3">
              <p class="cust">Service Location Collection</p>
              <el-select
                class=""
                placeholder="Select"
                v-model="item.servicelocationcollections"
                filterable
              >
                <el-option
                  v-for="option in selects.servicecollections"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
            <div class="col-lg-3">
              <p class="cust">Remark</p>
              <input
                type="text"
                v-model="item.remark"
                :class="{ 'custom-input': true }"
              />
            </div>
          </div>
          
          <br />
          <div class="row" style=" margin: 5px;">
            <div class="col-lg">
              <p class="cust">View Log</p>
            </div>
            </div>
          <div class="row" style="height: 150px; overflow: auto; margin: 5px;" >
            <div class="col-lg">
              <el-table
                :data="remarklogs"
                :header-cell-style="{
                  border: 'transparent',
                  'font-size': '14px',
                  'font-weight': '400',
                  color: '#707070',
                }"
                :cell-style="{ fontColor: '#707070' }"
                :row-style="tableRowClassName"
                style="color: #707070"
              >
                <el-table-column width="50">
                  <div slot-scope="scope">
                    <base-button
                      class="btn-icon btn-round btn-sm"
                      style="color: #ffffff; font-size: 13px"
                      >{{ scope.$index + 1 }}</base-button
                    >
                  </div>
                </el-table-column>
                <el-table-column
                  label="Created At"
                  prop="created_at"
                  width="150"
                >
                </el-table-column>
                <!-- <el-table-column label="Created By" prop="created_by">
                </el-table-column> -->
                <el-table-column label="Arrival ETA" prop="arrival_eta">
                </el-table-column>
                <el-table-column
                  label="Service Location Name"
                  prop="service_location_name"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  label="Service Location Collection Name"
                  prop="service_location_collection_name"
                  width="140"
                >
                </el-table-column>
                <el-table-column label="Remark" prop="remarks">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <br />

          <div class="row">
            <div class="col-lg text-right">
              <base-button @click="submit()">Save Changes</base-button>
            </div>
          </div>
        </b-card></modal
      >
      <modal :show.sync="modals.successModal">
        <div
          class="modal-header"
          style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15cf79;
          "
        >
          <div class="col-lg"></div>
          <div class="col-lg-5">
            <div
              style="
                padding: 15px;
                background-color: transparent;
                border-radius: 100px;
                border: 10px solid white;
              "
            >
              <i
                style="color: white; font-size: 90px; font-weight: 900"
                class="tim-icons icon-check-2"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Successful
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p
            style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #707070;
            "
          >
            Congratulations!
          </p>

          <p style="color: #A5A5A5">{{ message }}</p>

          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="primary" v-on:click="modals.successModal = false"
              >Okay</base-button
            >
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
import FullCalendar from "vue-fullcalendar";
import { BCard } from "bootstrap-vue";
import { Modal } from "src/components";
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimeSelect,
} from "element-ui";
import moment from "moment";
// import Card from "../../../components/Cards/Card.vue";
// import Calendar from "src/components/Calendar/Calendar.vue";
// import Calendar from "src/components/Calendar/CalendarCustom.vue";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    // Card,
    // Calendar,
    FullCalendar,
    Modal,
    BCard,
    [TimeSelect.name]: TimeSelect,
    [DatePicker.name]: DatePicker,
  },

  data() {
    return {
      remarklogs: [],
      tajuk: "",
      tarikh: "",
      tableData: [],
      jobno: "",
      year: "",
      month: "",
      modals: {
        noti: false,
        successModal: false,
      },
      message: "",
      demoEvents: [
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office qwertyuiop",
        //   start: "2024-01-14",
        //   end: "2024-01-14",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "hewwo",
        //   start: "2024-01-20",
        //   end: "2024-01-20",
        //   time: "13:00",
        //   cssClass: ["onschedule"],
        // },
      ],
      selects: {
        servicelocations: [],
        servicecollections: [],
      },
    };
  },
  methods: {
    getServiceLocationCollection(id) {
      console.log(id);
      this.selects.servicecollections = [];

      this.$http
        .get(":10001/api/v1/reference/service-location/" + id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].Name,
                value: response[i].ServiceLocationCollectionId,
              };

              this.selects.servicecollections.push(obj);
            }
          }
        });
    },
    getservicelocation() {
      this.selects.servicelocations = [];
      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };
            this.selects.servicelocations.push(obj);
          }
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      } else {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      }
    },
    getDownload() {},
    eventClick(event, jsEvent, pos) {
      this.tajuk =
        "JOB INFORMATION - " +
        moment(event.end, "YYYY-MM-DD").format("DD MMMM YYYY");

      this.tableData = [
        {
          customer: event.customer,
          jobno: event.jobno,
          start: event.start,
          end: event.end,
          time: "08:00",
          ship: event.ship == "" ? "-" : event.ship,
        },
      ];
      this.title = event.title;
      this.tarikh = moment(event.start, "YYYY-MM-DD").format("DD MMMM YYYY");
      this.modals.noti = true;

      this.getRemarksLogs(event.jobno);
    },
    getRemarksLogs(id) {
      this.remarklogs = [];
      this.$http
        .get(":10001/api/v1/incoming/" + id + "/calendar_log")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                arrival_eta: moment(response[i].arrival_eta).format(
                  "YYYY-MM-DD hh:mm a"
                ),
                service_location_name:
                  response[i].service_location_name == ""
                    ? "-"
                    : response[i].service_location_name,
                service_location_collection_name:
                  response[i].service_location_collection_name == ""
                    ? "-"
                    : response[i].service_location_collection_name,
                remarks: response[i].remarks,
                created_at: moment(response[i].created_at).format(
                  "YYYY-MM-DD hh:mm a"
                ),
                created_by: response[i].created_by,
              };
              this.remarklogs.push(obj);
            }
          }
        });
    },
    moreClick(date, events, jsEvent) {},
    dayClick(day, jsEvent) {},
    getDetail(year, month) {
      this.demoEvents = [];
      this.$http
        .get(":10001/api/v1/incoming/calendar?year=" + year + "&month=" + month)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              for (var j = 0; j < response[i].waste_jobs.length; j++) {
                // calculate delay or onschedule
                let moment1 = moment(
                  response[i].waste_jobs[j].arrival_eta
                ).format("YYYY-MM-DD");
                let moment2 = moment().format("YYYY-MM-DD");
                let delayflag = moment1 >= moment2 ? true : false;

                let flag = "";
                if (response[i].waste_jobs[j].reference_number == this.jobno) {
                  flag = ["owned"];
                } else if (
                  delayflag &&
                  response[i].waste_jobs[j].job_status_text == "complete"
                ) {
                  flag = ["onschedule"];
                } else if (
                  !delayflag &&
                  response[i].waste_jobs[j].job_status_text != "complete"
                ) {
                  flag = ["delay"];
                  // flag = ["delay"];
                } else if (
                  !delayflag &&
                  response[i].waste_jobs[j].job_status_text == "complete"
                ) {
                  flag = ["onschedule"];
                  // flag = ["delay"];
                } else if (
                  delayflag &&
                  response[i].waste_jobs[j].job_status_text != "complete"
                ) {
                  flag = ["onschedule"];
                  // flag = ["delay"];
                } else {
                }
                // console.log(delayflag);
                // if (!delayflag) {
                //   flag = ["onschedule"];
                // } else {
                //   flag = ["delay"];
                // }
                let obj = {
                  title:
                    // moment(response[i].waste_jobs[j].arrival_eta).format(
                    //   "HH:mm a"
                    // ) +
                    // " " +
                    response[i].waste_jobs[j].reference_number +
                    " " +
                    response[i].waste_jobs[j].company_name,

                  start:
                    // "2024-01-30",
                    moment(response[i].waste_jobs[j].arrival_eta).format(
                      "YYYY-MM-DD"
                    ),
                  end:
                    // "2024-01-30",
                    moment(response[i].waste_jobs[j].arrival_eta).format(
                      "YYYY-MM-DD"
                    ),
                  time: moment(response[i].waste_jobs[j].arrival_eta).format(
                    "HH:mm:ss a"
                  ),
                  customer: response[i].waste_jobs[j].company_name,
                  jobno: response[i].waste_jobs[j].reference_number,
                  cssClass: flag,
                  ship: response[i].waste_jobs[j].ship_name,
                  display: "background",
                  servicelocation:
                    response[i].waste_jobs[j].service_location_id,
                };
                this.demoEvents.push(obj);
              }
            }
          }
        });
    },
    handleMonthChange(start, end, current) {
      this.year = moment(current, "YYYY-MM-DD").format("YYYY");
      this.month = moment(current, "YYYY-MM-DD").format("M");

      this.getDetail(this.year, this.month);
    },
    submit() {
      let obj = {
        arrival_date: moment(this.tableData[0].end).format("YYYY-MM-DD"),
        arrival_time: this.tableData[0].time,
        service_location_id: this.tableData[0].servicelocation,
        service_location_collection_id:
          this.tableData[0].servicelocationcollections,
        remarks: this.tableData[0].remark,
      };
      this.$http
        .put(":10001/api/v1/incoming/" + this.tableData[0].jobno + "/date", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            this.getDetail(this.year, this.month);
            this.modals.noti = false;
          }
        });
    },
  },
  created() {
    this.getservicelocation();
    let year = moment().format("YYYY");
    let month = moment().format("M");

    // this.getDetail(year, month);
  },
  computed: {},
};
</script>
<style>
.comp-full-calendar {
  min-width: none !important;
  max-width: none !important;
  width: 100%;
  /* background: red; */
}

.header-center {
  text-align: right !important;
}

.header-right {
  display: none;
}
.day-cell .day-number {
  color: #A5A5A5;
  height: 101px;
}
.day-cell .not-cur-month {
  color: #A5A5A5 !important;
  opacity: 0.5;
}

.full-calendar-body .dates .week-row .day-cell:last-child,
.full-calendar-body .dates .week-row .day-cell:nth-child(6) {
  background-color: rgb(236, 234, 234) !important;
}

.onschedule {
  background: rgb(11, 170, 0) !important;
  color: #ffffff !important;
}

.delay {
  background: rgb(255, 153, 0) !important;
  color: #ffffff !important;
}

.onschedule {
  background: rgb(11, 170, 0) !important;
  color: #ffffff !important;
}

.delay {
  background: rgb(255, 153, 0) !important;
  color: #ffffff !important;
}

.fc-sun {
  background-color: blue;
}

.cust {
  color: #707070 !important;
  font-size: 14px !important;
  font-weight: bold;
}

.custtitle {
  color: #707070 !important;
  font-size: 14px !important;
}
</style>
